/*
precision highp float;
varying vec2 vUv;
uniform sampler2D texture;

void main(void) {
  gl_FragColor = texture2D(texture, vUv);
}
 */
export const FRAGMENT_SHADER_SOURCE =
  'precision highp float;varying vec2 vUv;uniform sampler2D texture;void main(void){gl_FragColor=texture2D(texture,vUv);}';
